import React from "react";
import * as Flags from "country-flag-icons/react/3x2";

/* Drapeau SVG (country-flag-icons) — les emoji drapeaux ne rendent pas sous
   Windows (lettres "US"), on affiche donc les vrais SVG embarqués. */
const Flag = ({ code, className = "", title }) => {
  const key = String(code || "").trim().toUpperCase();
  const C = key.length === 2 ? Flags[key] : null;
  if (!C) return null;
  return <C className={`flag-svg ${className}`} title={title || key} />;
};

export default Flag;
